var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tiledLayoutContainer",staticClass:"tiled-container"},[_vm._t("default",function(){return [_c('TiledRows',{attrs:{"rows":_vm.tiledSections}})]},{"tiledSections":_vm.tiledSections})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }